import { network } from 'services/network';
import { useMutation } from 'react-query';

const copyQualitySettings = (params) => {
    return network.post('api/bo/copyLogicCheckerConfigurationBetweenContracts', params).then((response) => {
        return response.data;
    });
};
export const useMutationCopyQualitySettings = () => {
    return useMutation<any, QueryError, ICopyQualitySettings>('copyQualitySettings', (params) =>
        copyQualitySettings(params),
    );
};

export interface ICopyQualitySettings {
    fromContractId: number;
    toContractIds: number[];
}
